'use strict';

import markdownit from 'markdown-it';

const md = markdownit();

class StoryViewController {
  constructor($scope,
              $filter,
              $window,
              $log,
              $q,
              $sce,
              $state,
              $stateParams,
              utils,
              config,
              StoriesService,
              DevicesService,
              I18nService) {

    const $t = $filter('translate');
    const STORY_TYPES = config.getConfigByKey('storyTypes');
    $scope.locale = I18nService.getLocale();

    angular.extend($scope, {
      performAction: performAction,
      back: back
    });

    init();

    function init() {
      if (!$stateParams.storyId) {
        $log.error('storyId query parameter should be set.');
        $window.history.back();
      }
      $scope.availableStories = $stateParams.availableStories;
      $scope.selectedStoryId = $stateParams.storyId;

      $scope.loading = true;

      $q.all([
        getStory(),
        initWatchers(),
        // getDeviceModel() // Do we need device model at all?
      ])
        .then(() => {
          $scope.loading = false;
        }, (err) => {
          utils.handleApiError(err);
          $scope.loading = false;
        });
    }

    function getStory(storyId) {
      if (!storyId && $stateParams.story) {
        $scope.story = $stateParams.story;
        if ($scope.story.pages) {
          $scope.story.pages.forEach(p => {
            p.contentHtml = $sce.trustAsHtml(renderMarkdown(p.content));
          });
        }
        return;
      }

      return StoriesService.getStory(storyId || $stateParams.storyId)
        .then((data) => {
          if (!data || !data.stories || !data.stories[0]) {
            return;
          }
          $scope.story = data.stories[0];
          let temp = getStoryType($scope.story.storyType);
          $scope.story.name = $t(temp.name);
          $scope.story.desc = $t(temp.desc);

          if ($scope.story.pages) {
            $scope.story.pages.forEach(p => {
              p.contentHtml = $sce.trustAsHtml(renderMarkdown(p.content));
            });
          }
        });
    }

    function getStoryType(type) {
      return STORY_TYPES.find(el => el.id == type);
    }

    function renderMarkdown(markdown) {
      if (!markdown || !angular.isString(markdown)) {
        return;
      }
      return md.render(markdown);
    }

    function initWatchers() {
      if (!$scope.availableStories || $scope.availableStories.length === 0) {
        return;
      }
      $scope.$watch('selectedStoryId', (newValue, oldValue) => {
        if (!oldValue || !newValue || newValue === oldValue) {
          return;
        }
        return getStory(newValue);
      });
    }

    function getDeviceModel() {
      if ($stateParams.deviceModel) {
        $scope.deviceModel = $stateParams.deviceModel;
      }
      return DevicesService.getDeviceModels({
        modelId: $stateParams.deviceModelId
      })
        .then((data) => {
          // data.categories;
        });
    }

    /**
     * Perform page action
     * @param action
     */
    function performAction(action) {
      if (!action) {
        return;
      }

      if (action.type === 1) { // link to another story
        $state.go('main.stories.view', {
          story: null,
          storyId: action.storyId,
          deviceModel: null,
          deviceModelId: $stateParams.deviceModelId
        });
      }
    }

    /**
     * Go to previous page
     */
    function back() {
      $window.history.back();
    }
  }
}

export default angular
  .module('main.stories.view', [])
  .controller('StoryViewController', StoryViewController)
  .name;
